/**
 * Portrait BG remover + AI background changer locales
 * (ja, ko, fr, es, it, de, pt, pl, ar)
 */

function makeSection(id, title, blocks) {
  return { id: id, title: title, blocks: blocks || [] }
}

function p(text) {
  return { type: 'paragraph', text: text }
}

function table(columns, rows) {
  return { type: 'table', columns: columns, rows: rows, variant: 'overview' }
}

function bullets(items) {
  return { type: 'bullets', items: items }
}

function tip(title, text) {
  return { type: 'tip', title: title, text: text }
}

function faqItem(question, answer) {
  return { type: 'faq-item', question: question, answer: answer }
}

function stepsBlock() {
  return { type: 'steps' }
}

function prosConsBlock() {
  return { type: 'pros-cons' }
}

function links(title, items) {
  return { type: 'links', title: title, items: items || [] }
}

function gallery(imageKeys, caption, cols, fit, ratio) {
  var items = (imageKeys || []).map(function (key) {
    return { imageKey: key }
  })
  return {
    type: 'gallery',
    items: items,
    caption: caption || '',
    cols: cols || 2,
    fit: fit || 'contain',
    ratio: ratio || 'portrait'
  }
}

function scenarioItem(title, text) {
  return { type: 'scenario-item', title: title, text: text }
}

function buildIntentSection(L) {
  var blocks = [p(L.scenarioIntro || '')]
  ;(L.scenarios || []).forEach(function (item) {
    blocks.push(scenarioItem(item.title, item.text))
  })
  return makeSection('search-intents', (L.sec && L.sec.intentsTitle) || (L.sec && L.sec.faqTitle) || 'Search intents', blocks)
}

function buildPortraitBody(L) {
  var sec = L.sec || {}
  var whatBlocks = [
    p(sec.whatP1),
    p(sec.whatAvatarP),
    gallery(['portrait-avatar-before', 'portrait-avatar-after'], sec.galleryAvatarCaption, 2, 'contain', 'portrait'),
    p(sec.whatIdP),
    gallery(['portrait-id-before', 'portrait-id-after'], sec.galleryIdCaption, 2, 'contain', 'portrait'),
    p(sec.whatLinkedInP),
    gallery(['portrait-linkedin-before', 'portrait-linkedin-after'], sec.galleryLinkedInCaption, 2, 'contain', 'portrait'),
    tip(sec.whatTipTitle, sec.whatTipText)
  ]
  var howBlocks = [p(sec.howP), stepsBlock()]
  if (sec.howTipTitle) howBlocks.push(tip(sec.howTipTitle, sec.howTipText))
  var useBlocks = [table(sec.useCols, sec.useRows)]
  if (sec.useTipTitle) useBlocks.push(tip(sec.useTipTitle, sec.useTipText))
  var hairBlocks = [bullets(sec.hairItems), p(sec.hairP)]
  var troubleBlocks = [table(sec.troubleCols, sec.troubleRows)]
  if (sec.troubleTipTitle) troubleBlocks.push(tip(sec.troubleTipTitle, sec.troubleTipText))
  return {
    overview: L.overview,
    practice: L.practice,
    compareIntro: L.compareIntro,
    workflow: L.workflow,
    scenarioIntro: L.scenarioIntro,
    sections: [
      makeSection('tldr', sec.tldrTitle, [
        table(sec.tldrCols, sec.tldrRows),
        p(sec.tldrP)
      ]),
      makeSection('what-it-does', sec.whatTitle, whatBlocks),
      makeSection('how-to-use', sec.howTitle, howBlocks),
      makeSection('edge-check', sec.edgeTitle, [
        table(sec.edgeCols, sec.edgeRows),
        p(sec.edgeP)
      ]),
      makeSection('use-cases', sec.useTitle, useBlocks),
      makeSection('hair-glasses', sec.hairTitle, hairBlocks),
      makeSection('troubleshooting', sec.troubleTitle, troubleBlocks),
      makeSection('pros-cons', sec.prosConsTitle, [prosConsBlock()]),
      makeSection('best-practices', sec.bestTitle, [
        bullets(sec.bestItems)
      ]),
      makeSection('miral-workflow', sec.miralTitle, [
        p(sec.miralP),
        links(sec.miralLinksTitle, sec.miralLinks)
      ]),
      buildIntentSection(L),
      makeSection('faq', sec.faqTitle, (sec.faqItems || []).map(function (item) {
        return faqItem(item[0], item[1])
      }))
    ],
    linksTitle: L.linksTitle,
    linksIntro: L.linksIntro,
    links: L.links,
    steps: L.steps,
    pros: L.pros,
    cons: L.cons,
    tips: L.tips,
    scenarios: L.scenarios,
    toolFaq: L.toolFaq
  }
}

function buildChangerBody(L) {
  var sec = L.sec || {}
  var removeBlocks = [
    p(sec.removeP1),
    p(sec.removeLifestyleP),
    gallery(['changer-lifestyle-before', 'changer-lifestyle-after'], sec.galleryLifestyleCaption, 2, 'contain', 'portrait'),
    p(sec.removeSocialP),
    gallery(['changer-social-before', 'changer-social-after'], sec.gallerySocialCaption, 2, 'contain', 'portrait'),
    p(sec.removePosterP),
    gallery(['changer-poster-before', 'changer-poster-after'], sec.galleryPosterCaption, 2, 'contain', 'portrait'),
    tip(sec.removeTipTitle, sec.removeTipText)
  ]
  var howBlocks = [p(sec.howP), stepsBlock()]
  if (sec.howTipTitle) howBlocks.push(tip(sec.howTipTitle, sec.howTipText))
  var qualityBlocks = [bullets(sec.qualityItems)]
  if (sec.qualityTipTitle) qualityBlocks.push(tip(sec.qualityTipTitle, sec.qualityTipText))
  return {
    overview: L.overview,
    practice: L.practice,
    compareIntro: L.compareIntro,
    workflow: L.workflow,
    scenarioIntro: L.scenarioIntro,
    sections: [
      makeSection('tldr', sec.tldrTitle, [
        table(sec.tldrCols, sec.tldrRows),
        p(sec.tldrP)
      ]),
      makeSection('remove-then-replace', sec.removeTitle, removeBlocks),
      makeSection('how-to-use', sec.howTitle, howBlocks),
      makeSection('scene-ideas', sec.sceneTitle, [
        table(sec.sceneCols, sec.sceneRows),
        p(sec.sceneP)
      ]),
      makeSection('quality-check', sec.qualityTitle, qualityBlocks),
      makeSection('vs-other-guides', sec.vsTitle, [
        table(sec.vsCols, sec.vsRows),
        p(sec.vsP)
      ]),
      makeSection('troubleshooting', sec.troubleTitle, [
        table(sec.troubleCols, sec.troubleRows)
      ]),
      makeSection('pros-cons', sec.prosConsTitle, [prosConsBlock()]),
      makeSection('best-practices', sec.bestTitle, [
        bullets(sec.bestItems)
      ]),
      makeSection('miral-workflow', sec.miralTitle, [
        p(sec.miralP),
        links(sec.miralLinksTitle, sec.miralLinks)
      ]),
      buildIntentSection(L),
      makeSection('faq', sec.faqTitle, (sec.faqItems || []).map(function (item) {
        return faqItem(item[0], item[1])
      }))
    ],
    linksTitle: L.linksTitle,
    linksIntro: L.linksIntro,
    links: L.links,
    steps: L.steps,
    pros: L.pros,
    cons: L.cons,
    tips: L.tips,
    scenarios: L.scenarios,
    toolFaq: L.toolFaq
  }
}

var LOCALE_BRAND = {
  ja: {
    links: {
      '/tools/background-remover': 'Miral AI 背景除去',
      '/tools/image-enhancer': 'AI画像強化',
      '/hub/articles/ai-background-changer-online': 'AI背景差し替えガイド',
      '/hub/articles/ai-portrait-background-remover': 'ポートレート・証明写真ガイド',
      '/hub/articles/ai-background-remover-online': '一般向けAI背景除去ガイド',
      '/hub/articles/ecommerce-product-background-removal': 'EC商品背景ガイド'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI 背景除去'],
      ['AI Background Remover', 'AI 背景除去'],
      ['AI Image Enhancer', 'AI画像強化'],
      ['Background Remover', '背景除去']
    ]
  },
  ko: {
    links: {
      '/tools/background-remover': 'Miral AI 배경 제거',
      '/tools/image-enhancer': 'AI 이미지 향상',
      '/hub/articles/ai-background-changer-online': 'AI 배경 교체 가이드',
      '/hub/articles/ai-portrait-background-remover': '인물·증명사진 가이드',
      '/hub/articles/ai-background-remover-online': '일반 AI 배경 제거 가이드',
      '/hub/articles/ecommerce-product-background-removal': '이커머스 상품 배경 가이드'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI 배경 제거'],
      ['AI Background Remover', 'AI 배경 제거'],
      ['AI Image Enhancer', 'AI 이미지 향상'],
      ['Background Remover', '배경 제거']
    ]
  },
  fr: {
    links: {
      '/tools/background-remover': 'Suppression d’arrière-plan Miral AI',
      '/tools/image-enhancer': 'Amélioration d’image IA',
      '/hub/articles/ai-background-changer-online': 'Guide de changement d’arrière-plan IA',
      '/hub/articles/ai-portrait-background-remover': 'Guide portrait et photo d’identité',
      '/hub/articles/ai-background-remover-online': 'Guide général de suppression d’arrière-plan IA',
      '/hub/articles/ecommerce-product-background-removal': 'Guide fond produit e-commerce'
    },
    replace: [
      ['Miral AI Background Remover', 'Suppression d’arrière-plan Miral AI'],
      ['AI Background Remover', 'Suppression d’arrière-plan IA'],
      ['AI Image Enhancer', 'Amélioration d’image IA'],
      ['Background Remover', 'Suppression d’arrière-plan']
    ]
  },
  es: {
    links: {
      '/tools/background-remover': 'Eliminador de fondo Miral AI',
      '/tools/image-enhancer': 'Mejorador de imágenes IA',
      '/hub/articles/ai-background-changer-online': 'Guía de cambio de fondo con IA',
      '/hub/articles/ai-portrait-background-remover': 'Guía de retrato y foto de carnet',
      '/hub/articles/ai-background-remover-online': 'Guía general de eliminación de fondo IA',
      '/hub/articles/ecommerce-product-background-removal': 'Guía de fondo de producto ecommerce'
    },
    replace: [
      ['Miral AI Background Remover', 'Eliminador de fondo Miral AI'],
      ['AI Background Remover', 'Eliminador de fondo IA'],
      ['AI Image Enhancer', 'Mejorador de imágenes IA'],
      ['Background Remover', 'Eliminador de fondo']
    ]
  },
  it: {
    links: {
      '/tools/background-remover': 'Rimozione sfondo Miral AI',
      '/tools/image-enhancer': 'Miglioramento immagini IA',
      '/hub/articles/ai-background-changer-online': 'Guida al cambio sfondo IA',
      '/hub/articles/ai-portrait-background-remover': 'Guida ritratto e foto tessera',
      '/hub/articles/ai-background-remover-online': 'Guida generale rimozione sfondo IA',
      '/hub/articles/ecommerce-product-background-removal': 'Guida sfondo prodotto ecommerce'
    },
    replace: [
      ['Miral AI Background Remover', 'Rimozione sfondo Miral AI'],
      ['AI Background Remover', 'Rimozione sfondo IA'],
      ['AI Image Enhancer', 'Miglioramento immagini IA'],
      ['Background Remover', 'Rimozione sfondo']
    ]
  },
  de: {
    links: {
      '/tools/background-remover': 'Miral AI Hintergrundentferner',
      '/tools/image-enhancer': 'KI-Bildverbesserung',
      '/hub/articles/ai-background-changer-online': 'KI-Hintergrundwechsel-Guide',
      '/hub/articles/ai-portrait-background-remover': 'Porträt- und Ausweisfoto-Guide',
      '/hub/articles/ai-background-remover-online': 'Allgemeiner KI-Hintergrundentferner-Guide',
      '/hub/articles/ecommerce-product-background-removal': 'E-Commerce-Produkthintergrund-Guide'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI Hintergrundentferner'],
      ['AI Background Remover', 'KI-Hintergrundentferner'],
      ['AI Image Enhancer', 'KI-Bildverbesserung'],
      ['Background Remover', 'Hintergrundentferner']
    ]
  },
  pt: {
    links: {
      '/tools/background-remover': 'Removedor de fundo Miral AI',
      '/tools/image-enhancer': 'Aprimorador de imagens IA',
      '/hub/articles/ai-background-changer-online': 'Guia de troca de fundo com IA',
      '/hub/articles/ai-portrait-background-remover': 'Guia de retrato e foto 3x4',
      '/hub/articles/ai-background-remover-online': 'Guia geral de remoção de fundo IA',
      '/hub/articles/ecommerce-product-background-removal': 'Guia de fundo de produto ecommerce'
    },
    replace: [
      ['Miral AI Background Remover', 'Removedor de fundo Miral AI'],
      ['AI Background Remover', 'Removedor de fundo IA'],
      ['AI Image Enhancer', 'Aprimorador de imagens IA'],
      ['Background Remover', 'Removedor de fundo']
    ]
  },
  pl: {
    links: {
      '/tools/background-remover': 'Usuwanie tła Miral AI',
      '/tools/image-enhancer': 'Wyostrzanie obrazów AI',
      '/hub/articles/ai-background-changer-online': 'Przewodnik zmiany tła AI',
      '/hub/articles/ai-portrait-background-remover': 'Przewodnik portretów i zdjęć do dokumentów',
      '/hub/articles/ai-background-remover-online': 'Ogólny przewodnik usuwania tła AI',
      '/hub/articles/ecommerce-product-background-removal': 'Przewodnik tła produktów e-commerce'
    },
    replace: [
      ['Miral AI Background Remover', 'Usuwanie tła Miral AI'],
      ['AI Background Remover', 'Usuwanie tła AI'],
      ['AI Image Enhancer', 'Wyostrzanie obrazów AI'],
      ['Background Remover', 'Usuwanie tła']
    ]
  },
  ar: {
    links: {
      '/tools/background-remover': 'أداة إزالة الخلفية من Miral AI',
      '/tools/image-enhancer': 'تحسين الصور بالذكاء الاصطناعي',
      '/hub/articles/ai-background-changer-online': 'دليل تغيير الخلفية بالذكاء الاصطناعي',
      '/hub/articles/ai-portrait-background-remover': 'دليل الصور الشخصية وصور الهوية',
      '/hub/articles/ai-background-remover-online': 'الدليل العام لإزالة الخلفية بالذكاء الاصطناعي',
      '/hub/articles/ecommerce-product-background-removal': 'دليل خلفية منتجات التجارة الإلكترونية'
    },
    replace: [
      ['Miral AI Background Remover', 'أداة إزالة الخلفية من Miral AI'],
      ['AI Background Remover', 'أداة إزالة الخلفية بالذكاء الاصطناعي'],
      ['AI Image Enhancer', 'تحسين الصور بالذكاء الاصطناعي'],
      ['Background Remover', 'أداة إزالة الخلفية']
    ]
  }
}

function replaceBrandText(text, pairs) {
  var out = String(text || '')
  var i
  for (i = 0; i < pairs.length; i++) {
    out = out.split(pairs[i][0]).join(pairs[i][1])
  }
  return out
}

function localizeLinkList(items, linkMap) {
  return (items || []).map(function (item) {
    if (!item || !item.path) return item
    var nextLabel = linkMap[item.path]
    if (!nextLabel) return item
    return Object.assign({}, item, { label: nextLabel })
  })
}

function deepLocalizeBrand(value, brand) {
  if (!brand) return value
  if (typeof value === 'string') return replaceBrandText(value, brand.replace || [])
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return deepLocalizeBrand(item, brand)
    })
  }
  if (!value || typeof value !== 'object') return value
  var out = {}
  Object.keys(value).forEach(function (key) {
    if (key === 'path') {
      out[key] = value[key]
      return
    }
    out[key] = deepLocalizeBrand(value[key], brand)
  })
  return out
}

function localizePack(pack, loc) {
  var brand = LOCALE_BRAND[loc]
  if (!brand || !pack) return pack
  var out = deepLocalizeBrand(pack, brand)
  if (brand.links) {
    if (out.sec && out.sec.miralLinks) {
      out.sec = Object.assign({}, out.sec, {
        miralLinks: localizeLinkList(out.sec.miralLinks, brand.links)
      })
    }
    if (out.links) {
      out.links = localizeLinkList(out.links, brand.links)
    }
  }
  return out
}

function localizeArticles(articles, loc) {
  var brand = LOCALE_BRAND[loc]
  if (!brand || !articles) return articles
  var out = {}
  Object.keys(articles).forEach(function (slug) {
    // Keep article-specific CTA labels; only rewrite brand phrases inside strings.
    out[slug] = deepLocalizeBrand(articles[slug], brand)
  })
  return out
}

function buildLocale(portraitPack, changerPack, articles, loc) {
  return {
    bodies: {
      'ai-portrait-background-remover': buildPortraitBody(localizePack(portraitPack, loc)),
      'ai-background-changer-online': buildChangerBody(localizePack(changerPack, loc))
    },
    articles: localizeArticles(articles, loc)
  }
}

var jaPack = require('./portraitChangerPacks/ja.js')
var koPack = require('./portraitChangerPacks/ko.js')
var frPack = require('./portraitChangerPacks/fr.js')
var esPack = require('./portraitChangerPacks/es.js')
var itPack = require('./portraitChangerPacks/it.js')
var dePack = require('./portraitChangerPacks/de.js')
var ptPack = require('./portraitChangerPacks/pt.js')
var plPack = require('./portraitChangerPacks/pl.js')
var arPack = require('./portraitChangerPacks/ar.js')

module.exports = {
  ja: buildLocale(jaPack.portrait, jaPack.changer, jaPack.articles, 'ja'),
  ko: buildLocale(koPack.portrait, koPack.changer, koPack.articles, 'ko'),
  fr: buildLocale(frPack.portrait, frPack.changer, frPack.articles, 'fr'),
  es: buildLocale(esPack.portrait, esPack.changer, esPack.articles, 'es'),
  it: buildLocale(itPack.portrait, itPack.changer, itPack.articles, 'it'),
  de: buildLocale(dePack.portrait, dePack.changer, dePack.articles, 'de'),
  pt: buildLocale(ptPack.portrait, ptPack.changer, ptPack.articles, 'pt'),
  pl: buildLocale(plPack.portrait, plPack.changer, plPack.articles, 'pl'),
  ar: buildLocale(arPack.portrait, arPack.changer, arPack.articles, 'ar')
}

